<template>
  <div class="product-list">
    <!-- 标题与保存按钮 -->
    <el-row>
      <el-col :span="12"><Title title="音效列表"></Title></el-col>
      <el-col :span="12">
        <div style="width:100%;height:60px;padding-right:15px;box-sizing:border-box" class="flex_rec">
          <el-button type="primary" @click="addObj('localFile')">上传本地音效</el-button>
          <el-button type="primary" @click="addObj('linkUrl')" plain>添加网络外链音效</el-button>
        </div>
      </el-col>
    </el-row>
    <el-card class="sound-preview-card" shadow="never">
      <div class="sound-preview-layout">
        <div class="sound-preview-heading">
          <span class="sound-preview-icon"><i class="el-icon-headset"></i></span>
          <div>
            <div class="sound-preview-title">音效试听</div>
            <div class="sound-preview-tip">点击列表中的试听按钮，在这里播放选中的音效</div>
          </div>
        </div>
        <Player :currSrc="currSrc" ref="player" class="sound-preview-player"></Player>
      </div>
    </el-card>
    <!-- 产品列表 -->
    <el-card class="box-card">
      <el-row :gutter="20" type="flex" align="middle" justify="start">
        <el-col :span="4">
          <el-input placeholder="请输入内容" v-model="search_op.search_name" @change="getList" clearable>
            <template slot="prepend">音效名</template>
          </el-input>
        </el-col>
        <el-col :span="1.5">
          创建时间
        </el-col>
        <el-col :span="3">
          <el-date-picker
            @change="getList"
            v-model="search_op.create_time_range"
            type="daterange"
            value-format="timestamp"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-col>
      </el-row>

      <el-row :gutter="20" type="flex" align="middle" justify="start" class="mt15">
        <el-col :span="4">
          <el-select v-model="search_op.status" placeholder="请选择音效状态" @change="getList">
            <el-option
              v-for="item in status_arr"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="search_op.category_id" placeholder="请选择分类" @change="getList">
            <el-option
              v-for="item in category_list"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="search_op.sort_type" placeholder="请选择排序" @change="getList">
            <el-option
              v-for="item in sort_type_list"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>

      <el-table
        :data="list"
        @selection-change="handleSelectionChange"
        style="width: 100%">
        <!-- <el-table-column type="expand">
          <template slot-scope="props">
            <el-table
              :data="props.row.skus"
              size="mini"
              :show-header="false"
              style="width: 100%">
              <el-table-column
                prop="sku_name"
                >

                <template slot-scope="scope">
                  <el-row>
                    <el-col :span="24">
                      <template v-if="scope.row.sku_name">
                        {{scope.row.sku_name}}
                      </template>
                      <template v-else>
                        {{props.row.name}}
                      </template>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">{{scope.row.sku_code}}</el-col>
                  </el-row>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column> -->
        <el-table-column
          type="selection"
          width="48">
        </el-table-column>
        <!-- 2026-09-29：标题可直接进入编辑；封面只在资源已有绑定时展示。 -->
        <el-table-column label="名字" min-width="260">
          <template slot-scope="scope">
            <div class="sound-identity">
              <el-image
                v-if="scope.row.cover_url"
                class="sound-cover"
                :src="scope.row.cover_url"
                :preview-src-list="[scope.row.cover_url]"
                fit="cover">
                <div slot="error" class="sound-cover-error">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div class="sound-title">
                <button
                  type="button"
                  class="sound-name-link"
                  :title="`编辑音效：${scope.row.name}`"
                  @click="handleEdit(scope.$index, scope.row)">{{ scope.row.name }}</button>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="分类" width="115" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.classify_name || '未分类' }}
          </template>
        </el-table-column>

        <el-table-column label="下载次数" width="95">
          <template slot-scope="scope">{{ scope.row.download_times || 0 }}</template>
        </el-table-column>

        <el-table-column label="喜欢总数" width="105">
          <template slot-scope="scope">{{ scope.row.favorite_count || 0 }}</template>
        </el-table-column>

        <el-table-column label="是否推荐" width="105">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.recommend==1" size="mini" type="warning">推荐</el-tag>
            <el-tag v-else size="mini" type="info">不推荐</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="是否启用" width="105">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status==1" size="mini" type="success">启用</el-tag>
            <el-tag v-else size="mini" type="danger">关闭</el-tag>
          </template>
        </el-table-column>

        <!-- 完整路径按需点击查看，不让长文件名挤占其他信息。 -->
        <el-table-column label="资源信息" min-width="225">
          <template slot-scope="scope">
            <div class="resource-badges">
              <el-tag size="mini" :type="soundSourceTagType(scope.row.media_source)">
                {{ soundSourceLabel(scope.row.media_source) }}
              </el-tag>
              <el-tag v-if="scope.row.media_source !== 'external'" size="mini" :type="resourceStatusTagType(scope.row.resource_status)">
                {{ resourceStatusLabel(scope.row.resource_status) }}
              </el-tag>
            </div>
            <el-popover
              v-if="scope.row.resource_path"
              placement="top-start"
              width="420"
              trigger="click">
              <div class="resource-popover-title">完整资源路径</div>
              <div class="resource-popover-path">{{ scope.row.resource_path }}</div>
              <el-button slot="reference" type="text" size="mini" class="resource-path-trigger">
                查看路径 <i class="el-icon-arrow-right"></i>
              </el-button>
            </el-popover>
            <span v-else class="sound-secondary">无可用路径</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <div class="sound-actions">
              <el-tooltip content="编辑音效" placement="top">
                <el-button class="action-icon-button" size="mini" type="primary" plain icon="el-icon-edit" aria-label="编辑音效" @click="handleEdit(scope.$index, scope.row)"></el-button>
              </el-tooltip>
              <el-tooltip content="试听音效" placement="top">
                <el-button class="action-icon-button" size="mini" icon="el-icon-video-play" aria-label="试听音效" @click="play(scope.$index, scope.row)"></el-button>
              </el-tooltip>
              <el-dropdown trigger="click" @command="handleRowCommand($event, scope.row)">
                <el-button class="action-icon-button" size="mini" icon="el-icon-more" aria-label="更多操作" title="更多操作"></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="copyTitle" icon="el-icon-document-copy">复制标题</el-dropdown-item>
                  <el-dropdown-item command="delete" icon="el-icon-delete" divided>删除音效</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page_num"
      :page-sizes="[5,10,15,20]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <el-card class="box-card" shadow="never" style="margin:5px 0">
      <el-row :gutter="5" type="flex" justify="center" align="middle">
        <el-col :span="3">已选择 {{soundsSelection.length}} 条</el-col>
        <el-col :span="3">批量：</el-col>
        <el-col :span="5"><el-button size="small" @click="setKeywords()" v-show="soundsSelection.length>0">设置关键词</el-button></el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import Title from "./components/Title"
import apis from "@/api/index"
import Player from "@/components/Player.vue"
import {
  buildSoundPreview,
  resourceStatusLabel,
  resourceStatusTagType,
  soundSourceLabel,
  soundSourceTagType
} from '@/lib/soundAdminUi'
export default {
    components:{
      Title,
      Player
    },
    name:'soundsList',
    data(){
      return {
        currSrc:"",
        status_arr:[
          {name:'启用/激活',value:1},
          {name:'禁用/未激活',value:0},
          {name:'所有',value:null},
        ],
        platform_arr:[
          {name:'win32',value:'win32'},
          {name:'darwin',value:'darwin'},
          {name:'所有',value:''},
        ],
        list:[],
        category_list:[],
        sort_type:'normal', //排序类型
        sort_type_list:[
          {name:'下载次数升序',value:'download_times_asc'},
          {name:'下载次数降序',value:'download_times_desc'},
          // 2026-09-29：服务端先按全部音效的喜欢数排序再分页，例如零喜欢的记录在升序时排前面。
          {name:'喜欢数升序',value:'favorite_count_asc'},
          {name:'喜欢数降序',value:'favorite_count_desc'},
          {name:'创建顺序降序',value:'create_time_desc'},
          {name:'创建顺序升序',value:'create_time_asc'},
          {name:'默认',value:'normal'},
        ],
        page_num:1,
        page_size:5,
        total:0,
        search_op:{sort_type:"normal"},
        soundsSelection:[],
      }
    },
    methods:{
			// 2026-09-28：模板统一使用服务端状态码映射，避免通过路径猜资源来源。
			resourceStatusLabel,
			resourceStatusTagType,
			soundSourceLabel,
			soundSourceTagType,
			confirm(ob,callback){
				this.$confirm(ob.msg, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: !ob.type?'warning':ob.type
				}).then(() => {
					callback()
				}).catch((e) => {
					console.error(e)
					this.$message({
						type: 'info',
						message: '已取消'
					});          
				});
			},
      getList(toS=true){
        if(toS){
          this.page_num = 1;
        }
        let op = {
          page_num:this.page_num,
          page_size:this.page_size
        }
        Object.assign(op,this.search_op)
        apis.sounds.read(op).then(res=>{
          console.log('res',res)
          this.list = (res.data.data.list || []).map((v)=>{
            return v;
          })
          this.total = res.data.data.count
          // let csvO = new csv([
          //   "name","tags","stock_sum"
          // ],this.list)
          // console.log('parse',csvO.parse())
          // console.log('parse',csvO.exportCsv())
        }).catch(err=>{
          console.log('err',err)
        })
      },
      getCategoryList(){
        apis.category.read(0).then(res=>{
          console.log('res',res)
          this.category_list = res.data.data
        }).catch(err=>{
          console.log('err',err)
        })
      },
      handleEdit(index, row) {
        this.$router.push({name:'updateSound',params:{obj:row},query:{id:row.id}})
        console.log(index, row);
      },
      /**
       * 2026-09-29：更多菜单只分发轻量操作，删除仍走原来的二次确认。
       * 例如选择“复制标题”只复制本行标题，不会修改音效资料。
       */
      handleRowCommand(command, row) {
        if (command === 'copyTitle') {
          this.copySoundTitle(row)
        } else if (command === 'delete') {
          this.handleDelete(0, row)
        }
      },
      /**
       * 2026-09-29：复制音效标题；旧浏览器或非安全上下文尝试传统复制。
       * 例如复制“雨声”后提示成功；浏览器拒绝复制时明确提示失败。
       */
      async copySoundTitle(row) {
        const title = row.name || ''
        if (!title) {
          this.$message.error('复制失败：音效标题为空')
          return
        }
        try {
          if (!navigator.clipboard || !navigator.clipboard.writeText) {
            throw new Error('Clipboard API unavailable')
          }
          await navigator.clipboard.writeText(title)
          this.$message.success('标题复制成功')
        } catch (error) {
          if (this.fallbackCopySoundTitle(title)) {
            this.$message.success('标题复制成功')
          } else {
            this.$message.error('标题复制失败，请检查浏览器剪贴板权限')
          }
        }
      },
      /**
       * 2026-09-29：为不支持 Clipboard API 的环境提供一次性复制输入框。
       * 例如管理页通过普通 HTTP 打开时，也能尝试复制“雨声”。
       */
      fallbackCopySoundTitle(title) {
        const textarea = document.createElement('textarea')
        textarea.value = title
        textarea.setAttribute('readonly', 'readonly')
        textarea.style.position = 'fixed'
        textarea.style.left = '-9999px'
        try {
          document.body.appendChild(textarea)
          textarea.select()
          return document.execCommand('copy')
        } catch (error) {
          return false
        } finally {
          if (textarea.parentNode) {
            textarea.parentNode.removeChild(textarea)
          }
        }
      },
      handleDelete(index, row) {
				let callback = ()=>{
          let op = {'sound_id':row.id}
          const loading = this.$loading({
            lock: true,
            text: '删除中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          apis.sounds.remove(op).then(res=>{
            console.log('res',res)
            if(res.data.code == 1){
              this.$message({message:res.data.msg, type:"success"})
              this.getList(false)
            }else{
              this.$message({message:res.data.msg, type:"error"})
            }
            loading.close()
          }).catch(err=>{
            loading.close()
            this.$message({message:err, type:"error"})
          })
				}
				this.confirm({msg:`确认删除当前音效 [${row.name}]？`},callback)
      },
      handleSizeChange(val) {
        this.page_size = val
        this.getList(false)
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.page_num = val
        this.getList(false)
        console.log(`当前页: ${val}`);
      },
      play(i,item){
        const preview = buildSoundPreview(item)
        if (!preview) {
          this.$message.warning('该音效暂无可用试听地址')
          return
        }
        this.$refs.player.play({
          src:preview.url,
          name:item.name
        })
        // this.audio.name = `${item.name}`;
        // this.$refs.aplayer.play();
        // audio.play();
      },
      addObj(addSourceType='localFile'){
        this.$router.push({name:'addSound',params:{addSourceType}})
      },
      setKeywords () {
        this.$router.push({name:'setKeywords',params:{sounds:this.soundsSelection}})
      },
      handleSelectionChange(val) {
        this.soundsSelection = val;
        console.log(this.soundsSelection)
      },
    },
    activated(){
      this.getList(false)
    },
    mounted(){
      this.getList()
      this.getCategoryList()
      // this.getSupplierList()

    }
}
</script>

<style lang="scss" scoped>
.product-list{
  padding:15px;
}

.sound-preview-card {
  margin-bottom: 16px;
  border-color: #e4e7ed;
  background: #f8fafc;
}

.sound-preview-layout {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px 24px;
}

.sound-preview-heading {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sound-preview-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #e8f2ff;
  color: #409eff;
  font-size: 18px;
}

.sound-preview-title {
  color: #303133;
  font-weight: 600;
}

.sound-preview-tip {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
}

.sound-preview-player {
  min-width: 300px;
}

.sound-identity {
  display: flex;
  align-items: center;
  min-width: 0;
}

.sound-cover {
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  margin-right: 10px;
  border-radius: 4px;
  cursor: pointer;
}

.sound-cover-error {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #c0c4cc;
}

.sound-title {
  min-width: 0;
  flex: 1;
}

.sound-name-link {
  display: block;
  max-width: 100%;
  padding: 0;
  border: 0;
  background: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  cursor: pointer;
  font: inherit;
  font-weight: 600;
  color: #303133;
}

.sound-name-link:hover,
.sound-name-link:focus {
  color: #409eff;
}

.sound-secondary {
  margin-top: 5px;
  color: #909399;
  font-size: 12px;
}

.resource-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.resource-path-trigger {
  margin-top: 4px;
  padding: 2px 0;
}

.resource-popover-title {
  margin-bottom: 8px;
  color: #909399;
  font-size: 12px;
}

.resource-popover-path {
  overflow-wrap: anywhere;
  word-break: break-all;
  line-height: 1.5;
  user-select: text;
}

.sound-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.sound-actions .action-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  margin: 0;
}

</style>
